import { getContext } from "svelte";
import { FORM_FIELD_CONTEXT } from "../internal/index.js";
export function getFormField() {
    return getContext(FORM_FIELD_CONTEXT);
}
